import { StyleSheet } from "aphrodite/no-important";

const trodlyGreen = "#33cc99";
// const trodlyBorder = "#dfdfdf";
const trodlyBlack = "#484848";
// const trodlyYellow = "#fdcd26";
const trodlyBgGrey = "#efefef";
const troldyFontGrey = "#a0a0a0";

// const trodlyFontLight = 300;
// const trodlyFontRegular = 400;
// const trodlyFontMedium = 500;

// const letterSpacing = 1.2;

const screenSize = {
  smartphone: "@media screen and (max-width: 20rem)",
  bigSmartphone: "@media screen and (max-width: 26.25rem)",
  tablet:
    "@media screen and (min-width: 48rem) and (max-width: 64rem) and (orientation: portrait)",
  tabletLandscape:
    "@media screen and (min-width: 48rem) and (max-width: 64rem) and (orientation: landscape)",
  mediumScreen: "@media screen and (max-width: 80rem)",
  bigScreen: "@media screen and (min-width: 80rem)"
};
export const ModalStyles = StyleSheet.create({
  modals: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "9999999999999"
  },
  close: {
    height: "2rem",
    width: "2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: "#fff",
    borderRadius: "100%",
    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.2)",
    position: "absolute",
    top: "-1rem",
    right: "-1rem",
    margin: 0,
    [screenSize.smartphone]: {
      height: "2rem",
      width: "2rem",
      top: "-1rem",
      right: "-1rem"
    }
  },
  closeIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    "::before": {
      content: '""',
      backgroundColor: trodlyBlack,
      position: "absolute",
      height: 2,
      width: "60%",
      transformOrigin: "center",
      transform: "rotate(45deg)"
    },
    "::after": {
      content: '""',
      backgroundColor: trodlyBlack,
      position: "absolute",
      height: 2,
      width: "60%",
      transformOrigin: "center",
      transform: "rotate(-45deg)"
    }
  },
  modalContainer: {
    backgroundColor: "#ffffff",
    width: "520px",
    minHeight: "20vh",
    marginTop: "2rem",
    borderRadius: 3,
    boxShadow: "0 0 15px 0 rgba(0,0,0,0.2)",
    position: "relative",
    padding: "1rem",
    [screenSize.bigSmartphone]: {
      width: "90%"
    }
  },
  modalHeader: {
    marginBottom: "1rem"
  },
  modalBody: {},
  modalFooter: {},
  next: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "1rem 0"
  },
  footerBanner: {
    backgroundColor: "#fbf8ec",
    height: "95px",
    width: "520px",
    marginTop: "1rem",
    borderRadius: 3,
    boxShadow: "1px 1px 6px 2px rgba(0, 0, 0, 0.15)",
    position: "relative",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [screenSize.bigSmartphone]: {
      width: "90%"
    }
  },
  footerBannerImage: {
    display: "block",
    width: 86,
    height: 60,
    objectFit: "contain"
  },
  footerBannerTitle: {
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "400",
    lineHeight: "1.44",
    textAlign: "left",
    color: "#484848",
    whiteSpace: "initial",
    marginLeft: 34
  }
});

export const BasicInfo = StyleSheet.create({
  numberOfPerson: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "0.8rem"
  },
  decrementIncrement: {
    height: "2.5rem",
    width: "3rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: trodlyBgGrey,
    // margin: '1rem',
    cursor: "pointer"
    // borderRadius: 5
  },
  whenButton: {
    padding: "0.5rem",
    backgroundColor: trodlyGreen,
    color: "#ffffff",
    cursor: "pointer",
    marginRight: "0.5rem",
    borderRadius: 3
  },
  containerID: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid " + troldyFontGrey,
    borderRadius: 3
  },
  error: {
    borderColor: "#ff4d2f"
  }
});
